import { useMutation } from "@tanstack/react-query"
import instance from "../instance"

export const useUploadImageToAWS=()=>{
    const uploadImg= async(formData)=>{
        const {data}= await instance.post(`/api/shopper/upload-img-to-aws`, formData)
        return data
    }
    const mutation = useMutation({
        mutationFn: uploadImg,
    })
    return mutation
}

